<section
  class="bg-[#F5F5F5] py-10 lg:py-20 space-y-5 px-3 md:px-5 2xl:px-28 3xl:px-52"
>
  <h3 class="font-semibold text-2xl md:text-3xl lg:text-4xl text-center">
    Browse by Models
  </h3>

  <!-- Arrows on small screens -->
  <div class="relative xl:hidden">
    <button
      (click)="scrollLeft()"
      class="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-OUT-Blue shadow-md rounded-full px-2 py-1 ml-1"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
      >
        <path
          class="text-white"
          fill="currentColor"
          fill-rule="evenodd"
          d="M10.53 2.97a.75.75 0 0 1 0 1.06L6.56 8l3.97 3.97a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 0"
          clip-rule="evenodd"
        />
      </svg>
    </button>
    <button
      (click)="scrollRight()"
      class="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-OUT-Blue shadow-md rounded-full px-2 py-1 mr-1"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 16 16"
      >
        <path
          class="text-white"
          fill="currentColor"
          fill-rule="evenodd"
          d="M5.47 13.03a.75.75 0 0 1 0-1.06L9.44 8L5.47 4.03a.75.75 0 0 1 1.06-1.06l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0"
          clip-rule="evenodd"
        />
      </svg>
    </button>

    <!-- Carousel container (Mobile) -->
    <div
      #scrollContainer
      class="container mx-auto flex overflow-x-auto gap-2 py-1.5 px-4 scroll-smooth"
    >
      <article class="shrink-0 w-[45%]" *ngFor="let model of models">
        <a [routerLink]="model.link">
          <div
            class="bg-white group hover:bg-black transition-all duration-300 shadow-md rounded-lg p-2 text-center"
          >
            <img [src]="model.image" alt="" class="mx-auto" />
            <p class="font-semibold group-hover:text-white transition-all">
              {{ model.model }}
            </p>
          </div>
        </a>
      </article>
    </div>
  </div>

  <!-- Desktop version (unchanged) -->
  <div
    class="mx-auto container hidden xl:flex overflow-x-auto gap-2 lg:gap-4 py-1"
  >
    <article class="shrink-0 w-[40%] lg:w-1/5" *ngFor="let model of models">
      <a [routerLink]="model.link">
        <div
          class="bg-white group hover:bg-black transition-all duration-300 shadow-md rounded-lg p-2 text-center"
        >
          <img [src]="model.image" alt="" class="mx-auto" />
          <p class="font-semibold group-hover:text-white transition-all">
            {{ model.model }}
          </p>
        </div>
      </a>
    </article>
  </div>
</section>
